import React, { Component } from 'react';
import './CandidateInterviewScheduleOverview.css';
import Button from '../../components/UI/Button/Button';
import Icon from '../../components/UI/Icon/Icon';
import candidateinterviewschedulercalendarmain from '../../assets/images/candidate-interview-scheduler-calendar-main.svg';
import interviewConfirmed from '../../assets/images/interview-confirmed.svg';
import interviewDeclined from '../../assets/images/interview_declined.svg';
import calendarimg from '../../assets/images/calenderpng.png';
import locationimg from '../../assets/images/locationpng.png';
import interviewExpired from '../../assets/images/expired.svg';
import Textarea from '../../components/UI/Textarea/Textarea';
import axios from '../../services/axios-service';
import ConsoleLog from '../../hoc/ConsoleLog/ConsoleLog';
import Linkify from 'react-linkify';
import moment from 'moment';
import download from 'downloadjs';
import { Image } from 'react-bootstrap';

/**
* @desc Interview Scheduler Candidate Interview Overview
* @version 0.1.0
* @author Praveen George
*/

class CandidateInterviewScheduleOverview extends Component {
  state = {
    interviewDetails:{},
    interviewConfirmed:"",
    confirmedSlot: "",
    errorMessage:'',
    candidateMessage:'',
    undoClass:false
  }

  componentDidMount() {
    axios.get("/galaxy/interview-scheduler/interviewee"+this.props.location.search).then(response => {
      //ConsoleLog("response",response.data)
      const interviewDetails = response.data;
      let interviewConfirmed="";
      let confirmedSlot = "";
        interviewDetails.intervieweeDetails.slots.map( slot => {
          slot.slot = slot.slot.substring(0, 19).replace("T", " ");
        });
      
        if(interviewDetails.intervieweeDetails.slots.find((slot)=> slot.status ==="ACCEPTED")) {
          interviewConfirmed = "ACCEPTED";
          confirmedSlot = interviewDetails.intervieweeDetails.slots.find((slot)=> slot.status ==="ACCEPTED").slot;
        }
        else if(interviewDetails.intervieweeDetails.slots.filter(slot=>moment(slot.slot) > moment()).every((slot)=> slot.status ==="REJECTED")){
          interviewConfirmed = "REJECTED";
        }
      this.setState({ 
        interviewDetails,
        interviewConfirmed,
        confirmedSlot
      });
    })
    .catch((error) => {
      ConsoleLog('error', error);
    });
  }
  
  confirmInterview = (e) => {
    let interviewDetails = this.state.interviewDetails;
    let expiredDate = interviewDetails.intervieweeDetails.slots.filter((slot)=> moment(slot.slot)>moment());
    if( expiredDate.find((slot)=> slot.status ==="ACCEPTED")) {
      this.setState({interviewConfirmed:"ACCEPTED"});
      this.postConfirmedData();
    }
    else if( expiredDate.every((slot)=> slot.status ==="REJECTED")){
      this.setState({interviewConfirmed:"REJECTED"});
      this.postConfirmedData();
    }
    else {
      if( expiredDate.every((slot)=> slot.status ==="PENDING")) {
        this.setState({errorMessage:" Please accept or decline the given time slots to confirm "})
      }
      else {
        this.setState({errorMessage: "Please check the remaining slots before confirming "});
      }
    }
  }

  postConfirmedData = ()=> {
    const confiremedData = {
      reference:this.props.location.search.substring(11),
      candidateMessage:this.state.candidateMessage,
      slots:this.state.interviewDetails.intervieweeDetails.slots
    }
    axios.post("galaxy/interview-scheduler/interviewee",JSON.stringify(confiremedData)).then((response)=>{
      // ConsoleLog("response",response.data)
    })
    .catch((error) => {
      ConsoleLog('error', error);
    });
    // ConsoleLog("confiremedData",JSON.stringify(confiremedData))
  }

  confirmSlot = (e,status,index,prevStatus) => {
    let interviewDetails = this.state.interviewDetails;
    let confirmedSlot = this.state.confirmedSlot;
    let slotIndex=index;
    let undoClass ="";
    interviewDetails.intervieweeDetails.slots[index].status = status;
    if(status == "ACCEPTED") {
      confirmedSlot = interviewDetails.intervieweeDetails.slots[slotIndex].slot;
      interviewDetails.intervieweeDetails.slots.map((slot,index)=> {
        if(slotIndex !==index && slot.status === "ACCEPTED") {
          slot.status = "PENDING";
        }
        
      })
    }

    if(status == "PENDING"){
      undoClass = index + prevStatus;
    }
    //ConsoleLog("confirmedSlot",confirmedSlot)
    this.setState({
      interviewDetails,
      confirmedSlot,
      errorMessage:'',
      undoClass
    });
  }

  downloadAttachment = (url,fileName) => {
    download(url,fileName);
  }

  dateFormater = (date) => {
    const duration = this.state.interviewDetails.intervieweeDetails.duration;
    var toDate = "";
    if(duration === "30 mins") {
      toDate = moment(date).add(30, 'minutes').format('hh:mma');
    } else {
      const durationArray = duration.split(" ")
      toDate = moment(date).add(durationArray[0], 'hours').format('hh:mma');
    }
    return moment(date).format('dddd, MMMM Do YYYY [ @ ]h:mma') + ' to ' +toDate
  }

  handleCandidateMessageChange = (e) => {
    e.preventDefault();
    let candidateMessage = this.state.candidateMessage; 
    candidateMessage = e.target.value;
    this.setState({candidateMessage });  
  }
  /**
  * @desc Add accept time slot to calendar
  * @param null
  * @return null
  */
  handleAddCalendar = () =>{
    axios.get("/galaxy/interview-scheduler/interviewee"+this.props.location.search+"&ics=1").then(response =>{
      // ConsoleLog("response",response.data)
      let icsData = response.data.ics;
      if(icsData){
      download(icsData,'interview-event.ics');
      }
    })
    .catch((error)=>{
      ConsoleLog('error', error);
    });
  }

  

  render() {
    

    let files = null;
    if(this.state.interviewDetails.interviewAttachments && this.state.interviewDetails.interviewAttachments !== ''){
      files = this.state.interviewDetails.interviewAttachments.split(";");
    }

    const interviewDetails=this.state.interviewDetails;
    const preferredTime=this.state.interviewDetails.intervieweeDetails && moment(this.state.interviewDetails.intervieweeDetails.slots[0].slot) < moment() ;
    return (
      <div className="cand-interview-overview-container-main">
      {interviewDetails.intervieweeDetails &&interviewDetails.intervieweeDetails.slots.every((slot)=> moment(slot.slot) < moment())?
      <div className="cand-interview-info-expired">
        <img src={interviewExpired}></img>
        <p className="cand-interview-head">Sorry!</p>
        <p className="cand-interview-title">The slots which have been selected for your interview with "<span className="client-company-name">{this.state.interviewDetails.companyName}</span>", "{this.state.interviewDetails.interviewTitle}", "{this.state.interviewDetails.interviewType}" have expired.</p>
        <p className="cand-interview-info">Please get in touch with your recruiter to reschedule</p>  
      </div>:
      <React.Fragment>
        <div className="cand-interview-info-attachements">
        <Linkify properties={{target: '_blank', style: {color: '#28b899', fontWeight: '400'}}}>
          <div>
            <img src={candidateinterviewschedulercalendarmain}></img>
            <p className="cand-nterview-title">Interview with <span className="client-company-name">{this.state.interviewDetails.companyName}</span> - <br></br>{this.state.interviewDetails.interviewTitle}</p>
            <p className="cand-nterview-info">{this.state.interviewDetails.interviewMessage}
              {/* <span>Kind Regards</span>
              <span>Clodagh Costello I Recruiter </span> */}
            </p>
          </div>
        </Linkify>
          { files? <div className="cand-interview-attachements">
            {files.map((file) => { 
              let regex = /(https:\/\/[\w\-\.]+\/\d+\/([^?]+))/g;
              let fileName = regex.exec(file);
              let fileNameDecoded = decodeURI(fileName[2]);
              return (
                <span onClick={() => this.downloadAttachment(file,fileNameDecoded)}><Icon className="download-file" icon="cand-attachement-download"></Icon><span className="attachmentTitle" title={fileNameDecoded}>{fileNameDecoded}</span></span>
              ) 
            })}
          </div>: null }
        </div>
        <div className="cand-interview-location-info">
          <div className="cand-green-bg interview-location-wrapper">
            <div className="interview-location-img"><Icon icon="candidate-interview-map"></Icon></div>
            <div className="interview-location-details"><span>Where:</span>At {this.state.interviewDetails.interviewLocation}</div>
          </div>
        </div>
        <div className={this.state.interviewConfirmed ===""?"cand-slots-messages-section":"cand-slots-messages-section success"}>
        <React.Fragment>
           <div className="cand-interview-timeslots-info">
            <p className="cand-interview-timeslots-header">Choose a time that suits you best</p>
            <p className="error-message">{this.state.errorMessage?this.state.errorMessage:" "}</p>  

            <div className= {"cand-green-bg"}>
              <div className="primary-slot-container">
              <Icon icon="calender" className="cand-interview-timeslots-calender" />
                <span className="primary-slot-text">When:</span>
                <p className={preferredTime?"strikethrough ":""}>
                  {this.state.interviewDetails.intervieweeDetails?
                    this.dateFormater(this.state.interviewDetails.intervieweeDetails.slots[0].slot)
                    :''
                  }
               </p>
              </div>
              {this.state.interviewDetails.intervieweeDetails && moment(this.state.interviewDetails.intervieweeDetails.slots[0].slot) < moment()?
             <div className="primary-slot-expired"><Icon icon="exclamation"/><span>Slot Expired</span></div>:
             <div className="primary-slot-buttons">
                <Button 
                  className={this.state.interviewDetails.intervieweeDetails && this.state.interviewDetails.intervieweeDetails.slots[0].status=="ACCEPTED"?"cand-interview-timeslots-acceptbutton button-succes":"cand-interview-timeslots-acceptbutton"}
                  onClick={(e)=>this.confirmSlot(e,"ACCEPTED",0)}>Accept
                </Button>
                <Button 
                  className={this.state.interviewDetails.intervieweeDetails && this.state.interviewDetails.intervieweeDetails.slots[0].status=="REJECTED"?"cand-interview-timeslots-declinebutton button-reject":"cand-interview-timeslots-declinebutton"} 
                  onClick={(e)=>this.confirmSlot(e,"REJECTED",0)}>Decline
                </Button>
              </div>
              }
            </div>
            {this.state.interviewDetails.intervieweeDetails && this.state.interviewDetails.intervieweeDetails.slots.length > 1 ? 
              <div className="cand-interview-alternative-timeslot">

              <p>or</p>
              
                {this.state.interviewDetails.intervieweeDetails.slots.map((slot,index) => {  
                    let disabledSlots = this.state.interviewDetails.intervieweeDetails && moment(this.state.interviewDetails.intervieweeDetails.slots[index].slot) < moment() ;
                    const undoClass = this.state.undoClass === index + "REJECTED"?" reject off":this.state.undoClass === index + "ACCEPTED"?" success off":"";            
                  if(index!==0) {
                    return(                      
                      <div className="secondary-slot-buttons">
                        <div className= {this.state.interviewDetails.intervieweeDetails.slots[index].status=="ACCEPTED" ?
                          "cand-green-bg success":this.state.interviewDetails.intervieweeDetails.slots[index].status=="REJECTED"?"cand-green-bg reject":"cand-green-bg" + undoClass}
                        >
                          <div className="secondary-slot-section">
                            <Icon icon={this.state.interviewDetails.intervieweeDetails.slots[index].status !=="PENDING" ?"calender_"+[index]+ "_selected":"calender"+[index]} className="cand-interview-timeslots-calender" />
                            <p className={disabledSlots?"strikethrough ":""}>
                            {this.dateFormater(slot.slot)}
                            </p>
                            {disabledSlots?<div className="secondary-slot-expired"><Icon icon="exclamation"/><span>Slot Expired</span></div>:
                            <React.Fragment>
                              {this.state.interviewDetails.intervieweeDetails.slots[index].status!=="PENDING"?
                                <Icon icon="undo-icon" title="Undo" className="cand-interview-timeslot-button undo-icon" onClick={(e)=>this.confirmSlot(e,"PENDING",index,slot.status)}/>                                
                                :<React.Fragment>
                                <Icon icon="tick-sign" className="cand-interview-timeslot-button tick-sign" onClick={(e)=>this.confirmSlot(e,"ACCEPTED",index)} />
                                <Icon icon="forbidden-mark" className="cand-interview-timeslot-button forbidden-mark" onClick={(e)=>this.confirmSlot(e,"REJECTED",index)}/>
                                </React.Fragment>
                              }
                           </React.Fragment>}
                          </div>
                        </div>
                      </div>
                    )
                  }
                })}
              </div>
              :''}
          </div>

          <div className="cand-interview-msg-section">
            <p>Have you any questions about your Interview?</p>
            <Textarea
              name="textarea-message" 
              placeholder="Please leave a message for your Recruiter (Optional).."
              value={this.state.candidateMessage}
              onChange={(event)=>this.handleCandidateMessageChange(event)}>
          </Textarea> 
            <Button 
              className="cand-interview-confirm-button"
              type='button'
              onClick={(e)=>this.confirmInterview(e)}>
              Confirm
            </Button>
          </div>
          </React.Fragment>
        
          <div className="cand-interview-confirmed">
            {this.state.interviewConfirmed ==="ACCEPTED"?
            <React.Fragment>
              <img src={interviewConfirmed}></img>
              <p className="confirmed-text">Your Interview has been Successfully Scheduled on</p>
              <p className="confirmed-date">{this.state.interviewConfirmed?this.dateFormater(this.state.confirmedSlot):''}</p>
              {/* <Button className="confirmed-date-add" onClick={()=>this.handleAddCalendar()}>Add to calendar</Button> */}
            </React.Fragment>
            :
            <React.Fragment>
              <img className="decline-img" src={interviewDeclined}></img>
              <p className="decline-text">We&apos;re sorry these times do not suit you</p>
              <p className="decline-info">Your recruiter will get back to you very soon</p>
            </React.Fragment>
            }
          </div> 
        </div>
        </React.Fragment>}
        <div style={{display:"none"}}>
          <img src={locationimg} width="0px" height="0px" />
          <img src={calendarimg} width="0px" height="0px" />
          <Image src={calendarimg} alt="logo" />
        </div>
      </div>
    )
  }
}
export default CandidateInterviewScheduleOverview;



// WEBPACK FOOTER //
// ./src/container/CandidateInterviewScheduleOverview/CandidateInterviewScheduleOverview.js